/* Clignote : scripts du thème */
(() => {
  const C = window.Clignote;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---------- argent ---------- */
  function money(cents) {
    const fmt = C.money || '{{amount_with_comma_separator}} €';
    const n = (cents || 0) / 100;
    const parts = (dec, th, ds) => {
      const [i, d] = n.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? ds + d : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: parts(2, ',', '.'),
      amount_no_decimals: parts(0, ',', '.'),
      amount_with_comma_separator: parts(2, '.', ','),
      amount_no_decimals_with_comma_separator: parts(0, '.', ','),
      amount_with_space_separator: parts(2, ' ', ','),
      amount_with_apostrophe_separator: parts(2, "'", '.'),
    }[k] || parts(2, '.', ',')));
  }
  C.formatMoney = money;

  /* ---------- toast ---------- */
  let toastT;
  function toast(msg, err) {
    const t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.toggle('err', !!err); t.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('show'), 2200);
  }

  /* ---------- slider mobile (.mslide) : points sous les cartes ---------- */
  $$('.mslide').forEach(track => {
    const cards = [...track.children]; if (cards.length < 2) return;
    const nav = document.createElement('div'); nav.className = 'mslide-dots'; nav.setAttribute('aria-hidden', 'true');
    nav.innerHTML = cards.map(() => '<button type="button" tabindex="-1"></button>').join('');
    track.after(nav);
    const dots = [...nav.children], step = () => cards[1].offsetLeft - cards[0].offsetLeft;
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (max <= 0) return;
      // autant de points que de positions possibles (les petites cartes tiennent à plusieurs par écran)
      const pages = Math.min(cards.length, Math.ceil(max / step() - 0.05) + 1);
      dots.forEach((d, j) => d.hidden = j >= pages);
      const i = track.scrollLeft >= max - 4 ? pages - 1 : Math.round(track.scrollLeft / step());
      dots.forEach((d, j) => d.classList.toggle('on', j === i));
    };
    track.addEventListener('scroll', sync, { passive: true }); addEventListener('resize', sync); sync();
    dots.forEach((d, j) => d.addEventListener('click', () => track.scrollTo({ left: j * step(), behavior: 'smooth' })));
  });

  /* ---------- menu mobile ---------- */
  const mb = $('.menu-btn'), mn = $('#mobile-nav');
  if (mb && mn) mb.addEventListener('click', () => {
    const open = mn.hidden; mn.hidden = !open; mb.setAttribute('aria-expanded', open);
  });

  /* ---------- sélecteurs langue / pays ---------- */
  $$('.loc-form select').forEach(s => s.addEventListener('change', () => s.form.submit()));

  /* ---------- panier (tiroir) ---------- */
  const drawer = $('#cart-drawer');
  function openDrawer() { if (!drawer) return location.href = C.routes.cart; drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); $('.panel', drawer).focus(); }
  function closeDrawer() { drawer?.classList.remove('open'); drawer?.setAttribute('aria-hidden', 'true'); }
  $$('[data-open-cart]').forEach(b => b.addEventListener('click', e => { if (drawer) { e.preventDefault(); refreshCart().then(openDrawer); } }));
  $$('[data-close-cart]').forEach(b => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  function esc(s) { return String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }

  function renderCart(cart) {
    $$('.cart-count').forEach(el => { el.textContent = cart.item_count || ''; el.dataset.count = cart.item_count; });
    if (!drawer) return;
    const items = $('.items', drawer);
    if (!cart.items.length) {
      items.innerHTML = `<p class="empty">${esc(C.t.empty)}</p>`;
    } else {
      items.innerHTML = cart.items.map((it, i) => `
        <div class="cart-line">
          ${it.image ? `<img src="${esc(it.image)}&width=168" alt="" width="84" height="84" loading="lazy">` : '<span></span>'}
          <div>
            <a href="${esc(it.url)}"><b>${esc(it.product_title)}</b></a>
            ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="v">${esc(it.variant_title)}</div>` : ''}
            <div class="qty">
              <button type="button" data-line="${i + 1}" data-q="${it.quantity - 1}" aria-label="-">−</button>
              <span>${it.quantity}</span>
              <button type="button" data-line="${i + 1}" data-q="${it.quantity + 1}" aria-label="+">+</button>
            </div>
            <button type="button" class="link-btn" data-line="${i + 1}" data-q="0">${esc(C.t.remove)}</button>
          </div>
          <b>${money(it.final_line_price)}</b>
        </div>`).join('');
    }
    $('[data-cart-total]', drawer).textContent = money(cart.total_price);
    $('[data-checkout]', drawer).toggleAttribute('disabled', !cart.items.length);
  }
  function refreshCart() { return fetch(C.routes.cart + '.js').then(r => r.json()).then(c => (renderCart(c), c)); }
  C.refreshCart = refreshCart;

  drawer?.addEventListener('click', e => {
    const b = e.target.closest('[data-line]'); if (!b) return;
    fetch(C.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: +b.dataset.line, quantity: Math.max(0, +b.dataset.q) }) })
      .then(r => r.json()).then(renderCart).catch(() => toast(C.t.error, true));
  });

  C.addToCart = function (items) {
    return fetch(C.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }) })
      .then(r => r.json().then(j => { if (!r.ok) throw new Error(j.description || j.message || C.t.error); return j; }))
      .then(() => refreshCart())
      .then(() => { toast(C.t.added); openDrawer(); })
      .catch(err => toast(err.message || C.t.error, true));
  };

  /* ---------- fiche produit ---------- */
  $$('[data-product]').forEach(root => {
    const data = JSON.parse($('script[data-product-json]', root).textContent);
    const form = $('form[data-product-form]', root);
    const idInput = $('input[name="id"]', form);
    const btn = $('[data-add]', root);
    const main = $('[data-main-img]', root);
    const thumbs = $$('[data-thumb]', root);
    const sticky = $('[data-sticky]', root);

    function current() {
      const opts = data.options.map((_, i) => $(`input[name="option${i + 1}"]:checked`, form)?.value);
      return data.variants.find(v => v.options.every((o, i) => o === opts[i]));
    }
    // vidéo en 1re position : elle passe devant l'image tant qu'on n'a pas choisi une photo
    const video = $('[data-main-video]', root);
    const videoThumb = $('[data-thumb-video]', root);
    let firstUpdate = true;
    if (videoThumb) videoThumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('on')); videoThumb.classList.add('on');
      video.hidden = false; video.play();
    });
    function showMedia(id) {
      const th = thumbs.find(t => t.dataset.thumb == id); if (!th) return;
      if (video) { video.hidden = true; video.pause(); videoThumb.classList.remove('on'); }
      thumbs.forEach(t => t.classList.toggle('on', t === th));
      main.style.opacity = 0;
      setTimeout(() => { main.src = th.dataset.src; main.srcset = th.dataset.srcset || ''; main.alt = th.dataset.alt || ''; main.style.opacity = 1; }, 120);
    }
    thumbs.forEach(t => t.addEventListener('click', () => showMedia(t.dataset.thumb)));

    function update() {
      const v = current();
      const gift = $('[data-gift]', root);
      const giftPrice = gift && gift.checked ? +gift.dataset.price : 0;
      $$('[data-opt-label]', root).forEach(el => { const i = +el.dataset.optLabel; el.textContent = $(`input[name="option${i}"]:checked`, form)?.value || ''; });
      if (!v) { btn.disabled = true; return; }
      idInput.value = v.id;
      const total = v.price + giftPrice;
      $$('[data-price]', root).forEach(el => el.textContent = money(total));
      $$('[data-compare]', root).forEach(el => el.textContent = v.compare_at_price > v.price ? money(v.compare_at_price + giftPrice) : '');
      $$('[data-off]', root).forEach(el => el.textContent = v.compare_at_price > v.price ? '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + ' %' : '');
      btn.disabled = !v.available;
      $$('[data-btn-label]', root).forEach(el => el.textContent = v.available ? C.t.add : C.t.soldout);
      if (v.featured_media && !(firstUpdate && video)) showMedia(v.featured_media);
      firstUpdate = false;
      // mise à jour des prix affichés dans les packs pour la couleur choisie
      $$('[data-pack-value]', root).forEach(p => {
        const idx = data.packIndex; if (idx < 0) return;
        const opts = data.options.map((_, i) => i === idx ? p.dataset.packValue : $(`input[name="option${i + 1}"]:checked`, form)?.value);
        const pv = data.variants.find(x => x.options.every((o, i) => o === opts[i]));
        if (!pv) return;
        $('[data-pack-price]', p).textContent = money(pv.price);
        const s = $('[data-pack-compare]', p); if (s) s.textContent = pv.compare_at_price > pv.price ? money(pv.compare_at_price) : '';
        const per = $('[data-pack-per]', p); if (per && +p.dataset.pairs > 1) per.textContent = money(Math.round(pv.price / +p.dataset.pairs)) + ' / ' + (p.dataset.unit || C.t.pair);
      });
      if (sticky) {
        const si = $('img', sticky); const th = thumbs.find(t => t.dataset.thumb == v.featured_media);
        if (si && th) si.src = th.dataset.src;
        $('[data-sticky-variant]', sticky).textContent = v.title;
      }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      const colorInputs = $$(`input[name="option${data.colorIndex + 1}"]`, form);
      root.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { ...v, colorIndex: colorInputs.findIndex(i => i.checked) } }));
    }
    form.addEventListener('change', update);
    $('[data-gift]', root)?.addEventListener('change', update);

    form.addEventListener('submit', e => {
      e.preventDefault();
      const v = current(); if (!v) return;
      const items = [{ id: v.id, quantity: 1 }];
      const gift = $('[data-gift]', root);
      if (gift && gift.checked) items.push({ id: +gift.value, quantity: 1 });
      btn.disabled = true;
      C.addToCart(items).finally(() => { btn.disabled = false; });
    });
    $$('[data-sticky-add]', root).forEach(b => b.addEventListener('click', () => form.requestSubmit()));

    if (sticky) new IntersectionObserver(([e]) => sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(btn);
    update();
  });

  /* ---------- simulateur LED : vraie grille 24 × 9 des lunettes, minuscules, 200 LED ---------- */
  // police minuscule de l'appli (6 lignes + jambage), format "ligne de départ:rangée|rangée"
  const RAW = {
    a:"1:.##.|...#|.###|#..#|.###", b:"0:#...|###.|#..#|#..#|#..#|###.", c:"1:.###|#...|#...|#...|.###", d:"0:...#|.###|#..#|#..#|#..#|.###",
    e:"1:.##.|#..#|####|#...|.###", f:"0:..##|.#..|###.|.#..|.#..|.#..", g:"1:.###|#..#|#..#|.###|...#|.##.", h:"0:#...|###.|#..#|#..#|#..#|#..#",
    i:"0:.#.|...|##.|.#.|.#.|###", j:"0:..#|...|.##|..#|..#|..#|##.", k:"0:#...|#..#|#.#.|##..|#.#.|#..#", l:"0:##.|.#.|.#.|.#.|.#.|###",
    m:"1:####.|#.#.#|#.#.#|#.#.#|#.#.#", n:"1:###.|#..#|#..#|#..#|#..#", o:"1:.##.|#..#|#..#|#..#|.##.", p:"1:###.|#..#|#..#|###.|#...|#...",
    q:"1:.###|#..#|#..#|.###|...#|...#", r:"1:#.##|##..|#...|#...|#...", s:"1:.###|#...|.##.|...#|###.", t:"0:.#..|###.|.#..|.#..|.#..|..##",
    u:"1:#..#|#..#|#..#|#..#|.###", v:"1:#...#|#...#|.#.#.|.#.#.|..#..", w:"1:#...#|#...#|#.#.#|#.#.#|.#.#.", x:"1:#...#|.#.#.|..#..|.#.#.|#...#",
    y:"1:#..#|#..#|.##.|..#.|.#..|#...", z:"1:####|..#.|.#..|#...|####",
    '0':"0:.##.|#..#|#..#|#..#|#..#|.##.", '1':"0:.#.|##.|.#.|.#.|.#.|###", '2':"0:.##.|#..#|..#.|.#..|#...|####", '3':"0:###.|...#|.##.|...#|...#|###.",
    '4':"0:#..#|#..#|####|...#|...#|...#", '5':"0:####|#...|###.|...#|#..#|.##.", '6':"0:.##.|#...|###.|#..#|#..#|.##.", '7':"0:####|...#|..#.|.#..|.#..|.#..",
    '8':"0:.##.|#..#|.##.|#..#|#..#|.##.", '9':"0:.##.|#..#|#..#|.###|...#|.##.",
    '!':"0:#|#|#|#|.|#", '?':"0:.##.|#..#|..#.|.#..|....|.#..", '.':"5:#", ',':"5:.#|#.", "'":"0:#|#", ':':"1:#|.|.|#", '-':"3:###", '+':"1:...|.#.|###|.#.",
    '♥':"1:.#.#.|#####|#####|.###.|..#..", '*':"1:#.#|.#.|#.#", ' ':"0:.."
  };
  // petite police 3 colonnes, utilisée par l'appli quand le mot ne tient pas en grand (ex. « mmmmm »)
  const RAW_S = {
    a:".#.|#.#|###|#.#|#.#", b:"##.|#.#|##.|#.#|##.", c:".##|#..|#..|#..|.##", d:"##.|#.#|#.#|#.#|##.", e:"###|#..|##.|#..|###", f:"###|#..|##.|#..|#..",
    g:".##|#..|#.#|#.#|.##", h:"#.#|#.#|###|#.#|#.#", i:"#|#|#|#|#", j:"..#|..#|..#|#.#|.#.", k:"#.#|#.#|##.|#.#|#.#", l:"#..|#..|#..|#..|###",
    m:"#...#|##.##|#.#.#|#...#|#...#", n:"##.|#.#|#.#|#.#|#.#", o:".#.|#.#|#.#|#.#|.#.", p:"##.|#.#|##.|#..|#..", q:".#.|#.#|#.#|##.|.##", r:"##.|#.#|##.|#.#|#.#",
    s:".##|#..|.#.|..#|##.", t:"###|.#.|.#.|.#.|.#.", u:"#.#|#.#|#.#|#.#|###", v:"#.#|#.#|#.#|#.#|.#.", w:"#...#|#...#|#.#.#|##.##|#...#", x:"#.#|#.#|.#.|#.#|#.#",
    y:"#.#|#.#|.#.|.#.|.#.", z:"###|..#|.#.|#..|###",
    '0':"###|#.#|#.#|#.#|###", '1':".#|##|.#|.#|.#", '2':"##.|..#|.#.|#..|###", '3':"##.|..#|.#.|..#|##.", '4':"#.#|#.#|###|..#|..#",
    '5':"###|#..|##.|..#|##.", '6':".##|#..|###|#.#|###", '7':"###|..#|.#.|.#.|.#.", '8':"###|#.#|###|#.#|###", '9':"###|#.#|###|..#|##.",
    '!':"#|#|#|.|#", '?':"##.|..#|.#.|...|.#.", '.':".|.|.|.|#", ',':".|.|.|#|#", "'":"#|#|.|.|.", ':':".|#|.|#|.", '-':"...|...|###|...|...",
    '♥':".#.#.|#####|.###.|..#..|.....", '*':"...|#.#|.#.|#.#|...", ' ':"..|..|..|..|.."
  };
  const build = (raw, small) => {
    const out = {};
    for (const [ch, def] of Object.entries(raw)) {
      const [top, rows] = small ? ['0', def] : def.split(':'); const rs = rows.split('|');
      const cols = new Array(Math.max(...rs.map(r => r.length))).fill(0);
      rs.forEach((r, ri) => [...r].forEach((c, x) => { if (c === '#') cols[x] |= 1 << (+top + ri); }));
      out[ch] = cols;
    }
    return out;
  };
  const FONT = build(RAW, false), FONT_S = build(RAW_S, true);
  const COLS = 24, ROWS = 9;
  // 200 LED : pas de LED sur le pont en haut (ligne 0) ni au-dessus du nez (lignes 7 et 8)
  const MASK = new Uint8Array(COLS * ROWS).fill(1);
  [[0, 9, 15], [7, 10, 14], [8, 9, 15]].forEach(([y, a, b]) => { for (let x = a; x < b; x++) MASK[y * COLS + x] = 0; });
  const clean = s => (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const colsOf = (s, f) => { const o = []; for (const ch of clean(s)) o.push(...(f[ch] || f['?'] || [0]), 0); o.pop(); return o; };
  const HEART = ['.##.##.', '#######', '#######', '.#####.', '..###..', '...#...'];

  /* mini-écrans LED animés des cartes « Ce qu'elles savent faire » */
  const HEART_PATH = [[3,0],[2,1],[1,2],[1,3],[2,4],[3,5],[4,6],[5,7],[6,6],[7,5],[8,4],[9,3],[9,2],[8,1],[7,0],[6,1],[5,2],[4,1]];
  $$('[data-led-mini]').forEach(cv => {
    const ctx = cv.getContext && cv.getContext('2d'); if (!ctx) return;
    cv.classList.add('on');
    const kind = cv.dataset.ledMini, W = cv.width, H = cv.height, cell = Math.min((W - 30) / COLS, (H - 24) / ROWS);
    const gx = (W - cell * COLS) / 2, gy = (H - cell * ROWS) / 2;
    const led = getComputedStyle(document.documentElement).getPropertyValue('--led').trim() || '#3b7bff';
    const txt = colsOf(cv.dataset.text || 'salut', FONT);
    let visible = false;
    new IntersectionObserver(([e]) => { visible = e.isIntersecting; if (visible) requestAnimationFrame(draw); }).observe(cv);
    function draw(t) {
      if (!visible) return;
      const px = new Uint8Array(COLS * ROWS), on = (x, y) => { if (x >= 0 && x < COLS && y >= 0 && y < ROWS) px[y * COLS + x] = 1; };
      if (kind === 'text') {
        const start = COLS - Math.floor(t / 110) % (txt.length + COLS);
        txt.forEach((col, i) => { for (let b = 0; b < 9; b++) if (col >> b & 1) on(start + i, b + 1); });
      } else if (kind === 'draw') {
        // un coeur dessiné point par point, comme au doigt, puis effacé
        // un coeur sur chaque verre, à côté du pont du nez qui n'a pas de LED
        const n = Math.floor(t / 90) % (HEART_PATH.length * 2 + 14);
        HEART_PATH.forEach(([x, y], i) => { if (i < n) on(1 + x, y + 1); if (i + HEART_PATH.length < n) on(13 + x, y + 1); });
      } else if (kind === 'music') {
        for (let c = 0; c < COLS; c++) {
          const h = Math.round((Math.sin(c * 0.9 + t / 160) * 0.5 + 0.5) * (Math.sin(c * 0.31 - t / 380) * 0.5 + 0.5) * ROWS * 1.15 + Math.random());
          for (let r = ROWS - 1; r >= ROWS - h; r--) on(c, r);
        }
      } else {
        // batterie qui se recharge
        for (let x = 5; x <= 17; x++) { on(x, 1); on(x, 7); }
        for (let y = 1; y <= 7; y++) { on(5, y); on(17, y); }
        for (let y = 3; y <= 5; y++) on(18, y);
        const lvl = Math.min(Math.floor(t / 280) % 7, 5);
        for (let k = 0; k < lvl; k++) for (let y = 3; y <= 5; y++) on(7 + k * 2, y);
      }
      ctx.clearRect(0, 0, W, H);
      for (let r = 0; r < ROWS; r++) for (let c = 0; c < COLS; c++) {
        if (!MASK[r * COLS + c]) continue;
        const x = gx + c * cell + cell / 2, y = gy + r * cell + cell / 2;
        if (px[r * COLS + c]) { ctx.shadowColor = led; ctx.shadowBlur = cell * 0.5; ctx.fillStyle = led; }
        else { ctx.shadowBlur = 0; ctx.fillStyle = '#211d2c'; }
        ctx.beginPath(); ctx.arc(x, y, cell * 0.32, 0, 7); ctx.fill();
      }
      ctx.shadowBlur = 0;
      requestAnimationFrame(draw);
    }
  });

  $$('[data-led-sim]').forEach(sim => {
    const cv = $('canvas', sim), ctx = cv.getContext('2d'), W = cv.width, H = cv.height;
    const msgIn = $('input', sim);
    const cell = Math.min((W - 160) / COLS, (H - 80) / ROWS);
    const gx = (W - cell * COLS) / 2, gy = (H - cell * ROWS) / 2;
    let ledColor = sim.dataset.color || '#3d8bff', mode = 'static';
    $$('.chip', sim).forEach(x => { x.classList.toggle('on', x.dataset.m === mode); x.setAttribute('aria-pressed', x.dataset.m === mode); });
    msgIn.addEventListener('input', () => { const v = clean(msgIn.value).replace(/[^a-z0-9!?.,':\-+* ]/g, ''); if (v !== msgIn.value) msgIn.value = v; });
    function setLed(c) {
      ledColor = c; sim.style.setProperty('--led', c);
      $$('.ledc button', sim).forEach(b => b.classList.toggle('on', b.dataset.c === c));
    }
    $('.ledc', sim)?.addEventListener('click', e => { const b = e.target.closest('button'); if (b) setLed(b.dataset.c); });
    $('.modes', sim)?.addEventListener('click', e => {
      const b = e.target.closest('.chip'); if (!b) return; mode = b.dataset.m;
      $$('.chip', sim).forEach(x => { x.classList.toggle('on', x === b); x.setAttribute('aria-pressed', x === b); });
    });
    // la couleur choisie sur la fiche produit se reflète dans le simulateur
    document.addEventListener('variant:change', e => {
      const b = $$('.ledc button', sim)[e.detail.colorIndex];
      if (b) setLed(b.dataset.c);
    });
    let visible = true;
    new IntersectionObserver(([e]) => { visible = e.isIntersecting; if (visible) requestAnimationFrame(draw); }).observe(cv);
    function draw(t) {
      if (!visible) return;
      ctx.clearRect(0, 0, W, H);
      // monture : bandeau noir avec l'encoche du nez
      const fx = gx - cell * 0.9, fy = gy - cell * 0.8, fw = cell * (COLS + 1.8), fh = cell * (ROWS + 1.4);
      ctx.save(); ctx.fillStyle = '#111018'; ctx.strokeStyle = '#2c2838'; ctx.lineWidth = 6;
      ctx.beginPath(); ctx.roundRect(fx, fy, fw, fh, [cell * 1.2, cell * 1.2, cell * 2.4, cell * 2.4]); ctx.fill(); ctx.stroke();
      ctx.fillStyle = '#0c0b12'; ctx.fillRect(0, fy + cell * 0.6, fx, cell * 0.7); ctx.fillRect(fx + fw, fy + cell * 0.6, W - fx - fw, cell * 0.7);
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath(); ctx.ellipse(W / 2, fy + fh, cell * 2.4, cell * 2.6, 0, Math.PI, 0); ctx.fill();
      ctx.restore();
      const px = new Uint8Array(COLS * ROWS), on = (x, y) => { if (x >= 0 && x < COLS && y >= 0 && y < ROWS) px[y * COLS + x] = 1; };
      if (mode === 'music') {
        for (let c = 0; c < COLS; c++) {
          const h = Math.round((Math.sin(c * 0.9 + t / 160) * 0.5 + 0.5) * (Math.sin(c * 0.31 - t / 380) * 0.5 + 0.5) * ROWS * 1.15 + Math.random());
          for (let r = ROWS - 1; r >= ROWS - h; r--) on(c, r);
        }
      } else if (mode === 'heart') {
        const beat = Math.sin(t / 220) > 0;
        [2, 15].forEach(x0 => HEART.forEach((r, y) => [...r].forEach((ch, x) => { if (ch === '#' && (beat || (y > 0 && y < 5 && x > 0 && x < 6))) on(x0 + x, 1 + y); })));
      } else {
        let tc = colsOf(msgIn.value || ' ', FONT), y0 = 1;
        if (tc.length > COLS) { const s = colsOf(msgIn.value, FONT_S); if (s.length <= COLS) { tc = s; y0 = 2; } }
        const len = tc.length; let start;
        // trop large même en petite police : ça défile, comme dans l'appli
        if (mode === 'static' && len <= COLS) start = Math.floor((COLS - len) / 2);
        else { const sp = Math.floor(t / 110) % (len + COLS); start = mode === 'right' ? sp - len : COLS - sp; }
        for (let i = 0; i < len; i++) for (let b = 0; b < 9; b++) if (tc[i] >> b & 1) on(start + i, b + y0);
      }
      for (let r = 0; r < ROWS; r++) for (let c = 0; c < COLS; c++) {
        if (!MASK[r * COLS + c]) continue;
        const x = gx + c * cell + cell / 2, y = gy + r * cell + cell / 2;
        if (px[r * COLS + c]) { ctx.shadowColor = ledColor; ctx.shadowBlur = cell * 0.45; ctx.fillStyle = ledColor; }
        else { ctx.shadowBlur = 0; ctx.fillStyle = '#24202f'; }
        ctx.beginPath(); ctx.arc(x, y, cell * 0.32, 0, 7); ctx.fill();
      }
      ctx.shadowBlur = 0;
      requestAnimationFrame(draw);
    }
    requestAnimationFrame(draw);
  });

  /* ---------- page panier (hors tiroir) ---------- */
  $$('[data-cart-page] [data-line]').forEach(b => b.addEventListener('click', () => {
    fetch(C.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: +b.dataset.line, quantity: Math.max(0, +b.dataset.q) }) }).then(() => location.reload());
  }));

  // Parrainage : ?parrain=CODE est gardé 30 jours puis attaché au panier (attribut caché _parrain, relu par l'appli de parrainage)
  try {
    const p = new URLSearchParams(location.search).get('parrain');
    if (p && /^[A-Z0-9]{4,12}$/i.test(p)) localStorage.setItem('clignote-parrain', JSON.stringify({ code: p.toUpperCase(), exp: Date.now() + 30 * 864e5 }));
    const s = JSON.parse(localStorage.getItem('clignote-parrain') || 'null');
    if (s && s.exp > Date.now()) {
      fetch(C.routes.cart + '.js').then(r => r.json()).then(c => {
        if (c.attributes?._parrain !== s.code)
          fetch(C.routes.cart + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _parrain: s.code } }) });
      });
    } else if (s) localStorage.removeItem('clignote-parrain');
  } catch (e) {}
})();
